import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import TopoSemMenu from "../../components/TopoSemMenu";
import Formulario from "./components/Formulario";
import Sucesso from "./components/Sucesso";

export default class MeusDados extends Component {
  render() {
    return (
      <div>
        <TopoSemMenu />
        <Switch>
          <Route path="/dados-pessoais/formulario" component={Formulario} />
          <Route path="/dados-pessoais/sucesso" component={Sucesso} />
        </Switch>
      </div>
    );
  }
}
